import './StepNavigator.scss';

export { default } from './StepNavigator';
